<template>
  <v-row v-if='mobileSearchBar' no-gutters class='align-center'>
    <v-btn
      icon
      @click='closeMobileSearchBar'
    >
      <v-icon>
        {{ mdiArrowLeft }}
      </v-icon>
    </v-btn>
    <v-text-field
      ref='mobileSearchField'
      v-model='searchText'
      label='Área, Curso ou Pilar'
      hide-details='auto'
      outlined
      rounded
      dense
      color='#0f505f'
      autofocus
      @keydown.enter='emitSearch(searchText)'
    />
    <v-spacer />
    <v-btn
      icon
      @click='emitSearch(searchText)'
    >
      <v-icon>
        {{ mdiMagnify }}
      </v-icon>
    </v-btn>
  </v-row>
  <v-row v-else class='align-center'>
    <v-col cols='2'>
      <img
        class='logo-ambia'
        src='@/assets/imgs/logo_ambia.png'
        alt='logo-ambia'
        @click='routeToHomeOrReload()'
      >
    </v-col>
    <v-col
      v-if='$vuetify.breakpoint.mdAndUp'
      cols='2'
    >
      <v-select
        v-model='searchType'
        :items='xp'
        item-text='name'
        item-value='type'
        item-disabled='customDisabled'
        label='Tipo da Experiência'
        hide-details='auto'
        dense
        outlined
      />
    </v-col>

    <v-col
      v-if='$vuetify.breakpoint.mdAndUp'
      cols='5'
    >
      <v-text-field
        v-model='searchText'
        label='Área, Curso ou Pilar'
        :prepend-inner-icon='mdiMagnify'
        hide-details='auto'
        outlined
        dense
        color='#0f505f'
        @change='emitSearch(searchText)'
      />
    </v-col>
    <v-col
      v-else
      cols='10'
      class='d-flex justify-end'
    >
      <v-btn
        icon
        @click='openMobileSearchBar'
      >
        <v-icon>
          {{ mdiMagnify }}
        </v-icon>
      </v-btn>

      <v-menu
        v-model='isUserLogoutMenuOpen'
        bottom
        transition='slide-y-transition'
        :offset-y='true'
      >
        <template v-slot:activator='{ on }'>
          <v-btn
            icon
            @click='() => isUserLogoutMenuOpen = !isUserLogoutMenuOpen'
            v-on='on'
          >
            <v-icon
              color='gray'
            >
              {{ mdiAccountCircleOutline }}
            </v-icon>
          </v-btn>
        </template>
        <v-list flat>
          <v-list-item-group>
            <v-list-item @click='redirect("ContentMyLists")'>
              <v-list-item-content>
                <v-list-item-title class='menu-item'>
                  MINHAS LISTAS
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              @click='goToDocs()'
            >
              <v-list-item-content>
                <v-list-item-title class='menu-item'>
                  AJUDA
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider
              class='mx-4'
            />

            <v-list-item @click='$refs.logoutmodalref.open()'>
              <v-list-item-content>
                <v-list-item-title class='menu-item'>
                  SAIR
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-col>
    <v-col
      v-if='$vuetify.breakpoint.mdAndUp'
      cols='3' class='text-right ambia-header-status-logout'
    >
      <div
        class='d-flex align-end justify-end py-1 px-2'
      >
        <div
          class='username d-flex justify-center align-center mb-0'
          @click='() => isUserLogoutMenuOpen = !isUserLogoutMenuOpen'
        >
          <span class='mr-2'>
            Olá, <strong>{{ userDisplayName }}</strong>
          </span>

          <div class='mx-1 expand-menu'>
            <v-menu
              v-model='isUserLogoutMenuOpen'
              bottom
              transition='slide-y-transition'
              :offset-y='true'
            >
              <template v-slot:activator='{ on }'>
                <v-icon
                  color='gray'
                  v-on='on'
                >
                  {{ mdiChevronDown }}
                </v-icon>
              </template>

              <v-list flat>
                <v-list-item-group>
                  <v-list-item @click='redirect("ContentMyLists")'>
                    <v-list-item-content>
                      <v-list-item-title class='menu-item'>
                        MINHAS LISTAS
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    @click='goToDocs()'
                  >
                    <v-list-item-content>
                      <v-list-item-title class='menu-item'>
                        AJUDA
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider
                    class='mx-4'
                  />

                  <v-list-item @click='$refs.logoutmodalref.open()'>
                    <v-list-item-content>
                      <v-list-item-title class='menu-item'>
                        SAIR
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </v-col>
    <LogoutModal ref='logoutmodalref' />
  </v-row>
</template>

<script>
import { mdiChevronDown, mdiMagnify, mdiMenu, mdiAccountCircleOutline, mdiArrowLeft } from '@mdi/js'
import LogoutModal from '@/components/LogoutModal'
export default {
  name: 'Ambiaheader',
  data: () => ({
    // Mudar para o seratchType ser o Todas e não Vídeos 360
    // searchType: { name: 'Vídeos 360', type: '360' },
    searchType: { name: 'Todas', type: 'all' },
    // Reorganizar o XP de tal forma que o Todas venha na frente
    xp: [
      { name: 'Todas', type: 'all'},
      { name: 'Experiências 360', type: '360' },
      { name: 'Realidade Aumentada', type: '3d' },
      { name: 'Simuladores', type: 'labs' },

    ],
    components:{
        LogoutModal
    },
    userDisplayName: '',
    showSettingsModal: false,
    isUserLogoutMenuOpen: false,
    searchText: '',
    mobileSearchBar: false,
    mdiChevronDown,
    mdiMagnify,
    mdiMenu,
    mdiAccountCircleOutline,
    mdiArrowLeft
  }),
  mounted() {
    // TODO(vignatti): use mapGetters to actually get this from Vuex
    this.userDisplayName = JSON.parse(localStorage.getItem('user')).displayName
    if (!this.userDisplayName)
      this.userDisplayName = JSON.parse(localStorage.getItem('user')).email
  },
  methods: {
    emitSearch(searchQuery) {
      let routeContent = ''
      let searchTypefix =
          this.searchType.type ? this.searchType.type : this.searchType
      if (searchTypefix == 'all'){
        routeContent = 'ContentSearchAll'
      } else {
        routeContent = 'ContentSearch'
      }
      this.$router.push({ name: routeContent,
          query: { query: searchQuery, type: searchTypefix } })
    },
    goToDocs () {
      window.open(
          'https://docs.imersys.com/docs/getting_started/searching.html',
          '_blank')
    },
    routeToHomeOrReload () {
      let homeContent = 'ContentHome'

      // If it is already routed to home then reload page, otherwise route over
      // there.
      if (this.$route['name'] === homeContent) {
        this.$router.go(this.$router.currentRoute)
      } else {
        this.$router.push({ name: homeContent })
      }
    },
    openMobileSearchBar() {
      this.mobileSearchBar = true
      if (this.searchText)
        this.emitSearch(this.searchText)
    },
    closeMobileSearchBar() {
      this.mobileSearchBar = false
      this.emitSearch('')
    },
    redirect (route) {
      this.$router.push({ name: route })
    },
  }
}
</script>
<style lang="scss" scoped>
.logo-ambia { width: 89px; cursor: pointer; vertical-align: middle;
  @media all and (max-width: 960px) { width: 89px; }
}

.username {
  &:hover { cursor: pointer; }
}

.menu-item { color: black !important; font-weight: 600 !important; }
</style>
